/**
 * Service layer — personal signature (Supabase-backed, per Clerk user)
 *
 * Wraps /api/user-signature. One saved signature per user, reused across any native PDF export
 * that needs a signature block (first consumer: the ASI PDF exporter). Components call only
 * these functions.
 */

async function call(method, body) {
  const token = await window.__clerkGetToken()
  const res = await fetch('/api/user-signature', {
    method,
    headers: method === 'GET'
      ? { 'Authorization': 'Bearer ' + token }
      : { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
    body: method === 'GET' ? undefined : JSON.stringify(body),
  })
  if (!res.ok) {
    const b = await res.json().catch(() => ({}))
    throw new Error(b.error || 'Signature request failed: ' + res.status)
  }
  return res.json()
}

/** Read the current user's saved signature, or null if they haven't set one up. */
export function getMySignature() {
  return call('GET', null).then(d => d.signature || null)
}

/** Save/replace the current user's signature. dataUrl is a base64 PNG data URL (draw/type/upload all converge here). */
export function saveSignature({ dataUrl, method, signerName, font }) {
  return call('POST', { action: 'saveSignature', dataUrl, method, signerName, font }).then(d => d.signature)
}

export function deleteMySignature() {
  return call('POST', { action: 'deleteSignature' }).then(d => d.ok)
}

/** Read a File (from an <input type="file">) as a base64 data URL, for the 'upload' capture method. */
export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}
